import React, { forwardRef, useState, useEffect } from "react";
import get from "lodash/get";

import GenericInputField, {
  TYPES,
} from "../../../../genericInputFields/genericInputField";
import { useFormContext } from "react-hook-form";

import { StyledSelectWrapper } from "./selectField.style";
import useAppContext from "../../../../../hooks/useAppContext";

const SelectField = forwardRef(
  ({ required, options, settings, placeholder, name, changeCallback }, ref) => {
    const { axios } = useAppContext();
    const {
      control,
      formState: { errors },
    } = useFormContext();
    const error = get(errors, name);
    const [selectOptions, setSelectOptions] = useState(null);

    useEffect(() => {
      if (options) {
        setSelectOptions(options);
      } else {
        const {
          optionsFetchFrom: { url, cacheKey },
        } = settings;
        const cachedItems = sessionStorage.getItem(cacheKey);
        if (cachedItems) {
          setSelectOptions(JSON.parse(cachedItems));
        } else {
          axios.get(url).then((resp) => {
            setSelectOptions(resp.data.data);
            sessionStorage.setItem(cacheKey, JSON.stringify(resp.data.data));
          });
        }
      }
    }, [options, settings]);

    return (
      <StyledSelectWrapper ref={ref}>
        {selectOptions && (
          <GenericInputField
            type={TYPES.SELECT_LABELED}
            name={name}
            required={required}
            placeholder={placeholder}
            options={selectOptions}
            control={control}
            error={error}
            changeCallback={changeCallback}
          />
        )}
      </StyledSelectWrapper>
    );
  },
);
SelectField.displayName = "SelectField";

export default SelectField;
